export enum Columns {
  Name = 'name',
  Access = 'access',
  Email = 'email',
  DateCreated = 'dateCreated',
  LastLogin = 'lastLogin',
  Actions = 'actions',
}
